// extracted by mini-css-extract-plugin
module.exports = {"title":"_89b4965636--title--iMiIc","promotions":"_89b4965636--promotions--J83hs"};